var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuotesDwon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.487,
    height: 21.262,
    viewBox: "0 0 24.487 21.262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "quotes_dwon",
    d: "M22.188,24.663a4.835,4.835,0,0,0,0-9.665c-4.7,0-1.566-9.341,4.7-9.341V3.4C15.708,3.4,11.328,24.663,22.188,24.663Zm-13.531,0a4.835,4.835,0,0,0,0-9.665c-4.7,0-1.567-9.341,4.7-9.341V3.4C2.176,3.4-2.2,24.663,8.657,24.663Z",
    transform: "translate(-2.399 -3.401)",
    fill: "#1f3a93"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotesDwon);
export default __webpack_public_path__ + "static/media/quotes_dwon.61da1a3f319140858658fb991746e3cb.svg";
export { ForwardRef as ReactComponent };